import { createContext, useState, useEffect, useContext } from 'react';
import { styled, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';

import NavigationBar from './NavigationBar';
import SideBar from './SideBar';

import Main from './Main';
import Fade from '@mui/material/Fade';
import { ReactElement } from 'react';
import { SetStateAction } from 'react';
import { LineChatAlertProvider } from '../../../../contexts/LineChatAlertContext';
export interface IMainLayoutProps {
  children: React.ReactNode
}

export interface IMainLayoutContext {
  navigationBarHeight: number,
  sideBarWidth: number;
  isSideBarOpen: boolean,
  animateDuration: number,
  animateEasing: string,
  topRightComponent: ReactElement,
  setTopRightComponent: any,
  toggleSideBar: () => void;
  closeSideBar: () => void,
  openSideBar: () => void
}

const PageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#F1F1F1',
}));


export const MainLayoutContext = createContext<Partial<IMainLayoutContext>>({})

export const useMainLayoutContext = () => {
  let context = useContext(MainLayoutContext) as IMainLayoutContext
  if (!context) {
    throw new Error('can not useMainLayout outside MainLayout')
  }
  return context
}

export default function MainLayout({ children }: IMainLayoutProps) {

  const theme = useTheme()

  const navigationBarHeight: number = 80
  const sideBarWidth: number = 270
  const animateDuration:number = theme.transitions.duration.leavingScreen
  const animateEasing:string = theme.transitions.easing.sharp

  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false)
  const [topRightComponent,setTopRightComponent] = useState(<></>)

  const toggleSideBar = (): void => {
    setIsSideBarOpen((prev) => !prev)
  }

  const openSideBar = ():void =>{
    setIsSideBarOpen(true)
  }

  const closeSideBar = ():void =>{
    setIsSideBarOpen(false)
  }

  useEffect(()=>{
    setIsSideBarOpen(true)
  },[])

  return (
    <MainLayoutContext.Provider value={{
      navigationBarHeight,
      sideBarWidth,
      topRightComponent,
      setTopRightComponent,
      isSideBarOpen,
      toggleSideBar,
      openSideBar,
      closeSideBar,
      animateDuration,
      animateEasing
    }}>
      <LineChatAlertProvider>
        <PageStyled>
          <SideBar />
          <Main>
            <Stack height={'100%'}>
              <NavigationBar />
              {children}
            </Stack>
          </Main>
        </PageStyled>
      </LineChatAlertProvider>
    </MainLayoutContext.Provider>
  );
}
